import React, { useRef } from "react";
import { Button, Grid } from "@material-ui/core";
import { useReactToPrint } from "react-to-print";
import GridItem from "../../components/Grid/GridItem";
import { baseUrl } from "../../config/api";
import axios from "axios";
import moment from "moment";
import html2pdf from "html2pdf.js";
import { useSelector } from "react-redux";

// Utility to generate PDF blob from a DOM node
function generateOrdersPDFBlobFromDOM(domNode) {
  return new Promise((resolve, reject) => {
    const opt = {
      margin: 0.5,
      filename: "orders.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };
    html2pdf()
      .set(opt)
      .from(domNode)
      .outputPdf("blob")
      .then(resolve)
      .catch(reject);
  });
}

const OrderItem = (props) => {
  let { orderNo, orderDetail, party, code, printCustomerName, imageName } = props.item;
  let {
    partyRef,
    lab,
    index,
    glassType,
    product,
    coat,
    rSph,
    rCyl,
    rAxis,
    rAddition,
    lSph,
    lCyl,
    lAxis,
    lAddition,
    ed,
    pd,
    prism,
    dia,
    fittingHeight,
    frameSection,
    quantity,
    note,
    clientName,
  } = orderDetail;

  return (
    <>
      <div style={{ marginBottom: 10 }} />
      <div className="text-center">
        <table className="table" border="1">
          <thead>
            {imageName && (
              <tr>
                <th colSpan="5" className="text-center" style={{ padding: "15px" }}>
                  <img
                    src={`${baseUrl}/uploads/${imageName}`}
                    alt="Product Image"
                    style={{
                      maxWidth: "100%",
                      width: "auto",
                      height: "auto",
                      maxHeight: "500px",
                      minHeight: "250px",
                      objectFit: "contain",
                      borderRadius: "8px",
                      border: "2px solid #333",
                      display: "block",
                      margin: "0 auto",
                      backgroundColor: "#ffffff",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </th>
              </tr>
            )}
            <tr>
              <th colSpan="1" className="text-center">
                Order # : {code.substring(0, code.length - 6)}
              </th>
              <th colSpan="3" className="text-center">
                Party Reference : {partyRef}
              </th>
              <th colSpan="1" className="text-center">
                Brand : {lab ? lab : ""}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th colSpan="2" className="text-center">
                Optician : {party.accountName}
              </th>
              {printCustomerName && (
                <th colSpan="3" className="text-center">
                  Customer Name : {clientName}
                </th>
              )}
            </tr>
            <tr>
              <th colSpan="1" className="text-center">Index : {index}</th>
              <th colSpan="1" className="text-center">Type : {glassType}</th>
              <th colSpan="2" className="text-center">
                Product : {product?.productName ? product.productName : ""}
              </th>
              <th colSpan="1" className="text-center">Coat : {coat ? coat : ""}</th>
            </tr>
            <tr>
              <th colSpan="1" className="text-center">SIDE</th>
              <th colSpan="1" className="text-center">SPH</th>
              <th colSpan="1" className="text-center">CYL</th>
              <th colSpan="1" className="text-center">AXIS</th>
              <th colSpan="1" className="text-center">ADD</th>
            </tr>
            <tr>
              <th colSpan="1" className="text-center">R</th>
              <td colSpan="1" className="text-center">{rSph}</td>
              <td colSpan="1" className="text-center">{rCyl}</td>
              <td colSpan="1" className="text-center">{rAxis}</td>
              <td colSpan="1" className="text-center">{rAddition}</td>
            </tr>
            <tr>
              <th colSpan="1" className="text-center">L</th>
              <td colSpan="1" className="text-center">{lSph}</td>
              <td colSpan="1" className="text-center">{lCyl}</td>
              <td colSpan="1" className="text-center">{lAxis}</td>
              <td colSpan="1" className="text-center">{lAddition}</td>
            </tr>
            <tr>
              <th colSpan="1" className="text-center">ED : {ed}</th>
              <th colSpan="1" className="text-center">PD : {pd}</th>
              <th colSpan="1" className="text-center">PRISM : {prism}</th>
              <th colSpan="1" className="text-center">DIA : {dia}</th>
              <th colSpan="1" className="text-center">FTH : {fittingHeight}</th>
            </tr>
            <tr>
              <th colSpan="3" className="text-center">Frame : {frameSection}</th>
              <th colSpan="2" className="text-center">Pair : {quantity}</th>
            </tr>
            <tr>
              <td colSpan="5" className="text-center">
                <b>Remark : </b>
                {note}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <br />
    </>
  );
};

const OrderPrintPage = (props) => {
  const componentRef = useRef();
  const authToken = useSelector((state) => state.userReducer.authToken);
  const userInfo = useSelector((state) => state.userReducer.userInfo);
  let { orders } = props.location.state;

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  async function handleWhatsappShare() {
    try {
      // if (!orders[0].whatsappNumber) {
      //   alert("Number doesnt exist.");
      // }
      // 1. Generate PDF blob from the DOM node
      const domNode = componentRef.current;
      const pdfBlob = await generateOrdersPDFBlobFromDOM(domNode);

      // 2. Prepare template parameters
      const recipientName = orders[0]?.labName || orders[0]?.customerName || "Customer";
      const startDate = moment.min(orders.map(o => moment(o.createdAt))).format("DD/MM/YYYY");
      const endDate = moment.max(orders.map(o => moment(o.createdAt))).format("DD/MM/YYYY");
      const totalOrders = orders.length;
      const senderName = userInfo?.name || "Your Company Name"; // Use logged-in user or fallback

      const phoneNumber = orders?.[0]?.whatsappNumber || orders?.[0]?.mobile;
      if (!phoneNumber) {
        alert("No WhatsApp number found for this recipient.");
        return;
      }

      // 3. Prepare form data
      const formData = new FormData();
      formData.append("file", pdfBlob, "orders.pdf");
      formData.append("phone", phoneNumber);
      formData.append("template", "send_lab_prescription_orders");
      formData.append("recipientName", recipientName); // {{1}}
      formData.append("startDate", startDate);         // {{2}}
      formData.append("endDate", endDate);             // {{3}}
      formData.append("totalOrders", totalOrders);     // {{4}}
      formData.append("senderName", senderName);       // {{5}}


      // 4. Send to backend
      const response = await axios.post(`${baseUrl}/send-whatsapp/ledgers`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.data.success) {
        alert("Orders sent successfully on WhatsApp!");
      } else {
        throw new Error(response.data.message || "Failed to send WhatsApp message");
      }
    } catch (error) {
      alert(error.response?.data?.message || error.message || "Failed to send orders on WhatsApp");
    }
  }

  return (
    <div>
      <Button color="primary" onClick={handlePrint}>
        Print Orders
      </Button>
      <Button color="primary" onClick={handleWhatsappShare}>
        Send WhatsAPPhere
      </Button>

      <Grid ref={componentRef} container style={{ alignItems: "center" }}>
        {orders.map((o, idx) => (
          <GridItem xs={12} md={12} sm={12} key={idx}>
            <OrderItem item={o} />
          </GridItem>
        ))}
      </Grid>
    </div>
  );
};

export default OrderPrintPage;